import { render, staticRenderFns } from "./faq-list.vue?vue&type=template&id=5fbb8104&scoped=true&"
import script from "./faq-list.vue?vue&type=script&lang=js&"
export * from "./faq-list.vue?vue&type=script&lang=js&"
import style0 from "./faq-list.vue?vue&type=style&index=0&id=5fbb8104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb8104",
  null
  
)

export default component.exports